import React from 'react';
import {connect} from 'react-redux'
import modalDismiss from '../../actions/modalDismiss';
import MessageModal from "./MessageModal";
import CRLReasonsModal from "./CRLReasonsModal";
import CertDetailsModal from "./CertDetailsModal";
import SystemInformationModal from "./SystemInformationModal";
import AdminUsersModal from "./AdminUsersModal";
import AdminWebservicesModal from "./AdminWebservicesModal";
import AdminConfigurationsModal from "./AdminConfigurationsModal";
import GenerateP12Modal from "./GenerateP12Modal";
import DatesModal from "./DatesModal";

const MODAL_COMPONENTS = {
    MESSAGE_MODAL: MessageModal,
    CRL_REASONS_MODAL:CRLReasonsModal,
    CERT_DETAILS_MODAL:CertDetailsModal,
    SYSTEM_INFORMATION_MODAL: SystemInformationModal,
    ADMIN_USERS_MODAL: AdminUsersModal,
    ADMIN_WEBSERVICES_MODAL: AdminWebservicesModal,
    ADMIN_CONFIGURATIONS_MODAL: AdminConfigurationsModal,
    P12_MODAL: GenerateP12Modal,
    DATES_MODAL: DatesModal
};

const Modal = (props) => {

    if (!props.modal.modalType) {
        return null
    }

    const dismissModal = () => {
        props.modalDismiss();
    };

    const SpecificModal = MODAL_COMPONENTS[props.modal.modalType];
    const modalProps = {
        onOk: dismissModal,
        onCancel: dismissModal,
        maskClosable: true,
        ...props.modal.modalProps,
        className: 'text-center'
    };
    return <SpecificModal modalProps={modalProps} {...props.modal.componentProps} />;

};

function mapStateToProps(state) {
    return {
        modal: state.modal
    }
}

export default (connect(mapStateToProps, {modalDismiss})(Modal));